(function () {
  var storageKey = 'gundex-theme-mode';
  var root = document.documentElement;

  function readMode() {
    try {
      return localStorage.getItem(storageKey) || 'dark';
    } catch (error) {
      return 'dark';
    }
  }

  function writeMode(mode) {
    try {
      localStorage.setItem(storageKey, mode);
    } catch (error) {
      return;
    }
  }

  function applyMode(mode) {
    root.classList.toggle('gdx-light', mode === 'light');
    root.classList.toggle('gdx-dark', mode !== 'light');
    var button = document.querySelector('.gdx-mode-toggle');
    if (button) {
      button.setAttribute('aria-pressed', String(mode === 'light'));
      button.querySelector('.gdx-mode-toggle__label').textContent = mode === 'light' ? 'Light' : 'Dark';
    }
  }

  function addModeToggle() {
    if (document.querySelector('.gdx-mode-toggle')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gdx-mode-toggle';
    button.innerHTML = '<span class="gdx-mode-toggle__dot" aria-hidden="true"></span><span class="gdx-mode-toggle__label">Dark</span>';
    button.addEventListener('click', function () {
      var nextMode = root.classList.contains('gdx-light') ? 'dark' : 'light';
      writeMode(nextMode);
      applyMode(nextMode);
    });

    document.body.appendChild(button);
  }

  function addEmptyCatalogMessage() {
    if (!/\/collections|\/products|\/search/.test(window.location.pathname)) return;
    if (document.querySelector('.product-grid__item, .product-information, .product-media-gallery__placeholder-image')) return;
    if (document.querySelector('.gdx-empty-catalog')) return;

    var main = document.querySelector('#MainContent');
    if (!main) return;

    var message = document.createElement('section');
    message.className = 'gdx-download gdx-empty-catalog';
    message.innerHTML = '<p class="gdx-kicker">Store preview</p><h2>The store is taking shape.</h2><p>Products have not been staged on this page yet, but the Gundex storefront is being built out now. Check back soon or head to the main site for the app.</p><a class="gdx-button gdx-button--primary" href="https://gundex.io/" target="_blank" rel="noopener">Visit gundex.io</a>';
    main.prepend(message);
  }

  function wireFeaturedCarousel() {
    var rail = document.querySelector('[data-gdx-carousel]');
    if (!rail) return;

    var nextButton = document.querySelector('[data-gdx-carousel-next]');
    var prevButton = document.querySelector('[data-gdx-carousel-prev]');
    var firstCard = rail.querySelector('.gdx-preview-strip__card');
    var step = firstCard ? firstCard.getBoundingClientRect().width + 14 : rail.clientWidth * 0.8;

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        rail.scrollBy({ left: -step, behavior: 'smooth' });
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        rail.scrollBy({ left: step, behavior: 'smooth' });
      });
    }
  }

  function boot() {
    applyMode(readMode());
    addModeToggle();
    wireFeaturedCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
